<template>
  <div>
    <div class="box-card">
        <div class="box-user item text">
            <el-table :data="sortedUsers" style="width: 100%" max-height="800px">

                <el-table-column label="ユーザー名" min-width="320px" prop="user.name">
                  <template v-slot="{ row }">
                    <div v-if="row.boldFlag === true">
                      <b><a href="#!" @click.prevent="onClickUserName(row)" 
                        >{{ row.user.name }}
                      </a></b>
                    </div>
                    <div v-else>
                      <a href="#!" @click.prevent="onClickUserName(row)" 
                        >{{ row.user.name }}
                      </a>
                    </div>
                  </template>
                </el-table-column>

            </el-table>
        </div>
        <div class="box-notice item text">
          <p>{{ NoticeUserName }}</p>
          <div 
            v-if="sortedNotices.length"
            class="timeline timeline-one-side"
            data-timeline-content="axis"
            data-timeline-axis-style="dashed"
            max-height="800px">

            <!-- <div v-for="notice in sortedNotices" :key="notice.id" class="timeline-block"> -->
            <div v-for="notice in sortedNotices" :key="notice.id" class="timeline-block">
              <!-- アイコン表示 -->
              <span class="timeline-step" :class="[`badge-${notice.iconType}`]">
                <i :class="notice.iconClass"></i>
              </span>
              <div class="timeline-content">

                <!-- 日時 タイトル表示 -->
                <div class="d-flex justify-content-between pt-1">                  
                  <div v-if="notice.Readed === true">
                    <span class="text-sm">{{ notice.createdAt }} &emsp; </span>
                    <b><span>{{ notice.rawData.notice.title }}</span></b>
                  </div>
                  <div v-else>
                    <b><span class="text-sm">{{ notice.createdAt }} &emsp; </span></b>
                    <b><span>{{ notice.rawData.notice.title }}</span></b>
                  </div> 

                </div>

                <!-- 発信者表示 -->
                <div v-if="notice.Readed === true" class="text-sm">発信者：
                  <span class="text-sm">{{
                    notice.createUserName
                  }}</span>
                </div>
                <div v-else class="text-sm font-weight-bold">発信者：
                  <span class="text-sm font-weight-bold">{{
                    notice.createUserName
                  }}</span>
                </div>

                <!-- 発信箇所表示 type=2（検査個所）の時のみ表示-->
                <div v-if="notice.type === '2'">
                  <div v-if="notice.Readed === true" class="text-sm mt-1 mb-0">発信箇所：
                    <u>
                      <a v-if="notice.linkedId" href="#!" @click.prevent="onClickLinkedId(notice.type, notice.linkedId)">
                        <span style="white-space:pre-wrap; word-wrap:break-word;">{{notice.rawData.notice.sourceName}}</span>    
                      </a>
                    </u>
                  </div>
                  <div v-else class="text-sm font-weight-bold mt-1 mb-0">発信箇所：
                    <u>
                      <a v-if="notice.linkedId" href="#!" @click.prevent="onClickLinkedId(notice.type, notice.linkedId)">
                        <span class="font-weight-bold" style="white-space:pre-wrap; word-wrap:break-word;">{{notice.rawData.notice.sourceName}}</span>    
                      </a>
                    </u>
                  </div>
                </div>

                <!-- 内容表示 -->
                <div v-if="notice.Readed === true" class="text-sm mt-1 mb-0">内容：
                  <span v-if="!notice.linkedId" style="white-space:pre-wrap; word-wrap:break-word;">{{ notice.content }}</span>
                  <a v-if="notice.linkedId" href="#!" @click.prevent="onClickLinkedId(notice.type, notice.linkedId)">
                    <span v-if="notice.linkedId" style="white-space:pre-wrap; word-wrap:break-word;">{{ notice.content }}</span>
                  </a>
                </div>
                <div v-else class="text-sm mt-1 mb-0 font-weight-bold">内容：
                  <span v-if="!notice.linkedId" style="font-weight:bold;white-space:pre-wrap; word-wrap:break-word;">{{ notice.content }}</span>
                  <a v-if="notice.linkedId" href="#!" @click.prevent="onClickLinkedId(notice.type, notice.linkedId)">
                    <span v-if="notice.linkedId" style="font-weight:bold;white-space:pre-wrap; word-wrap:break-word;">{{ notice.content }}</span>
                  </a>
                </div>

                <!-- ここから未読 -->
                <div v-if="notice.notReaded === true">
                  <span class="text-sm mt-1">---------------------------- ここから未読 ---------------------------------</span>
                </div>

              </div>
            </div>
          </div>
          <!-- <div v-else>
            <small>お知らせはありません</small>
          </div> -->

        </div>
    </div>
  </div>
</template>

<style scoped>
.text {
  font-size: 18px;
}

.item {
  padding: 18px 18px;
}

.box-user {  
  width: 400px;
  height: 820px ;
  background:white;
  /* overflow: scroll; */
  /*overflow: hidden visible;*/
}

.box-notice {
  /*width: calc( 100% - 400px );*/
  width: 100%;
  height: 820px ;
  background:white;
  overflow-y: scroll;
}

.box-card {
  width: 100%;
  height: 100% ;
  display: flex;
}
</style>
<script>
//import { MoreFilled } from '@element-plus/icons-vue'
import Session from "@/appSession/Session"
import ViewModel from "@/appViews/Notice/ViewModel/NoticeListVM"

export default {  
  data() {
    return {
      tenantId: "",
      userSub: "",
      session: null,
      viewModel: null,
      NoticeUserName: "",
      UserList: [],
      noticeList: [],
    };
  },
  computed: {
    sortedUsers() {
      // ユーザー名の昇順でソート
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.UserList.sort((a, b) => {
        return a.user.name < b.user.name ? -1: 1;
      });
    },

    sortedNotices() {
      // 日付の降順でソート      
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      let workList = this.noticeList.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      // 未読線を入れる箇所を取得
      if (workList.length > 0) {      
        let isNotReaded = false;
        for (let i=workList.length-1; i>=0; i--)
        {
          if (isNotReaded == false) {
            if (workList[i].Readed == false){
              workList[i].notReaded = true;
              isNotReaded = true;
            } else {
              workList[i].notReaded = false;
            }
          } else {
            workList[i].notReaded = false;
          }
        }
      }
      return workList;
    },
  },  
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    this.init().then(() => {
      console.log(`init end`)
    })
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    async init() {
      this.showLoader(true);
      // if (!this.$store.state.session.id) {
      //   // セッションIDがない場合はログイン画面に遷移する
      //   this.$router.push({
      //     name: 'Signin'
      //   })
      // }
      // this.session = await Session.init(this.$store.state.session.id)
      // console.log(`session--: ${JSON.stringify(this.session.info)}`)
      const userInfo = await this.$root.getUserInfo()
      this.tenantId = userInfo.group
      this.userSub = userInfo.sub

      // ユーザー一覧取得
      await this.dispUserList();
      this.showLoader(false);

      // テナント有効期限、ユーザーのログインチェック
      if (!await this.$root.validateSession()) {
        return
      }
    },

    /**
     * ユーザー一覧取得
     * @param {*} data
     */    
    async dispUserList(){
      this.viewModel = new ViewModel(this.tenantId, this.userSub);
      await this.viewModel.init();
      this.UserList = this.viewModel.data;
    },

    /**
     * ユーザークリック時の処理
     * @param {*} data
     */    
    async onClickUserName(row) {
      this.showLoader(true);
      this.NoticeUserName = row.user.name + " さん 通知内容一覧";
      // 通知情報取得
      console.log("row.user.userId" + row.user.userId);
      await this.viewModel.getNoticeInfo(row.user.userId);
      this.noticeList = this.viewModel.noticeList;

      // 取得した通知情報の未読分は全て既読にする
      for (let i=0; i<this.noticeList.length; i++) {
        if (this.noticeList[i].Readed == false) {
          let param = this.noticeList[i].rawData;
          param.notice.Readed = true;
          this.viewModel.updateNoticeReaded(param);
        }
      }

      // お知らせ有無フラグを更新（未読なしに更新）
      let sk = `${String(this.userSub)}#${row.user.userId}`
      let response = await this.viewModel.getNoticeStatusInfo(sk);
      for (let i=0; i<response.length;i++){
        let param = response[i];
        if (param.noticestatus.flg == true){
          param.noticestatus.flg = false;
          this.viewModel.updateNoticeStatusFlg(param)
        }
      }

      // 画面のユーザー名の太字を無効にする
      row.boldFlag = false;
      this.showLoader(false);
    },

    async onClickLinkedId(type, linkedId) {

      if (type == "2"){ // 検査個所の場合
        let noticeStore = this.$store.state.notice
        noticeStore.linkedId = linkedId
        this.$store.commit("setNotice", noticeStore)
        let projectId = linkedId.split("#")[1]
        let project = this.$store.state.project;
        project = {
          project: {
            id: projectId
          }
        };
        
        this.$store.commit("setProject", project);

        this.$router.push({
          path: `/projectMain`
        });
      }
    },

    showLoader(isShow) {
      if (isShow) {
        this.loader = this.$loading.show();
      } else {
        if (this.loader === null) {
          return;
        }
        this.loader.hide();
        this.loader = null;
      }
    },    
  }
};
</script>
